import React, { useCallback, useMemo } from "react"

import { JsonCodeEditor } from "@/components/JsonCodeEditor"
import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import { WEBSOCKET_TOOLTIPS } from "./tooltips"
import { DEFAULT_MEDIA_TEMPLATE, type WebSocketFieldProps } from "./types"
import { validateMediaTemplate } from "./utils"

export const MediaFormatFields: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  const mediaTemplateError = useMemo(
    () => validateMediaTemplate(metadata.send_media_template || ""),
    [metadata.send_media_template],
  )

  const handleMediaTemplateChange = useCallback(
    (value: string) => {
      onMetadataUpdate({ send_media_template: value })
    },
    [onMetadataUpdate],
  )

  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-coval-text">Media Format</h4>

      <div className="space-y-2">
        <FieldLabel tooltip={WEBSOCKET_TOOLTIPS.sendMediaTemplate}>
          Media Send Template
        </FieldLabel>
        <JsonCodeEditor
          ariaLabel="Media Send Template"
          placeholder={DEFAULT_MEDIA_TEMPLATE}
          value={metadata.send_media_template || ""}
          onChange={handleMediaTemplateChange}
          rows={6}
          disabled={disabled}
          error={mediaTemplateError}
          // `{{media_data}}` may stand in for a whole value, which a plain parse
          // rejects; validateMediaTemplate substitutes it first.
          lint={false}
        />
        <p className="text-xs text-coval-text-muted">
          JSON template for sending media. Must contain the{" "}
          <code className="bg-surface-1 px-1 rounded">{"{{media_data}}"}</code>,
          and may include{" "}
          <code className="bg-surface-1 px-1 rounded">{"{{media_name}}"}</code>
          {" / "}
          <code className="bg-surface-1 px-1 rounded">{"{{mime_type}}"}</code>.
        </p>
      </div>
    </div>
  )
}
